import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const CustomEffectIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M19.5 3.1875C19.853 3.1875 20.1723 3.328 20.4082 3.55469C20.4147 3.56058 20.4225 3.56505 20.4287 3.57129C20.4346 3.5772 20.4387 3.58472 20.4443 3.59082C20.6716 3.8268 20.8125 4.14652 20.8125 4.5V19.5C20.8125 20.2249 20.2249 20.8125 19.5 20.8125H4.5C3.77513 20.8125 3.1875 20.2249 3.1875 19.5V4.5C3.1875 3.77513 3.77513 3.1875 4.5 3.1875H19.5ZM8.74121 19.6875H19.5C19.6036 19.6875 19.6875 19.6036 19.6875 19.5V13.5898L8.74121 19.6875ZM5.1084 19.6875H6.42969L6.69629 19.5391L19.6875 12.3027V5.10742L5.1084 19.6875ZM4.46094 17.3027L4.3125 17.5684V18.8916L18.8926 4.3125H11.6914L4.46094 17.3027ZM4.5 4.3125C4.39645 4.3125 4.3125 4.39645 4.3125 4.5V15.2559L10.4043 4.3125H4.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

// No FPL replacement on purpose: this glyph is bespoke to the Gen Effect node and has no
// equivalent in the FPL icon set, so it renders in both flag states (themed via the FPL color var
// when the flag is on). It previously mapped to `Icon24ShaderEffect` — do not restore that.
export const CustomEffectIcon = fplIcon(CustomEffectIconLocal);
